function getLocaleCode(lang) {
    return String(lang?.code ?? lang ?? '')
        .trim()
        .toUpperCase()
        .replace('_', '-');
}

/**
 * Currency for a language is read from the language object's `currency_code`
 * field. When the caller passes a plain code we look the language up in the
 * `languages` list. EUR is the last-resort fallback.
 *
 * @param {object|string|null|undefined} lang
 * @param {Array<object>} [languages]
 */
export function resolveCurrencyCodeByLanguage(lang, languages = []) {
    const direct = String(lang?.currency_code ?? '').trim().toUpperCase();
    if (direct) {
        return direct;
    }

    const locale = getLocaleCode(lang);
    if (locale && Array.isArray(languages) && languages.length > 0) {
        const exact = languages.find(
            (item) => getLocaleCode(item) === locale
        );
        const base = locale.split('-')[0];
        const baseMatch = languages.find(
            (item) => getLocaleCode(item).split('-')[0] === base
        );
        const fromList = String(
            (exact?.currency_code ?? baseMatch?.currency_code) ?? ''
        ).trim().toUpperCase();
        if (fromList) {
            return fromList;
        }
    }

    return 'EUR';
}
